import ToastPlugin, { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(ToastPlugin, {
  })

  return {
    provide: {
      toast: useToast(),
    },
  }
})
